// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 9_sVMYeXThos
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import LoginInput from "../../LoginInput"; // plasmic-import: IUjDjOBqC9S0/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicAddClientModal.module.css"; // plasmic-import: 9_sVMYeXThos/css

createPlasmicElementProxy;

export const PlasmicAddClientModal__VariantProps = new Array();

export const PlasmicAddClientModal__ArgProps = new Array();

const $$ = {};

function PlasmicAddClientModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__jbx69
        )}
      >
        {"Company Name"}
      </div>
      <LoginInput
        data-plasmic-name={"companyNameInput"}
        data-plasmic-override={overrides.companyNameInput}
        className={classNames("__wab_instance", sty.companyNameInput)}
      />

      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text___3P7G3
        )}
      >
        {"Contact Name"}
      </div>
      <LoginInput
        data-plasmic-name={"contactNameInput"}
        data-plasmic-override={overrides.contactNameInput}
        className={classNames("__wab_instance", sty.contactNameInput)}
      />

      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__n8SlJ
        )}
      >
        {"Email"}
      </div>
      <LoginInput
        data-plasmic-name={"emailInput"}
        data-plasmic-override={overrides.emailInput}
        className={classNames("__wab_instance", sty.emailInput)}
      />

      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text___5UxQc
        )}
      >
        {"Custom Invoice ID (optional)"}
      </div>
      <LoginInput
        data-plasmic-name={"identifier"}
        data-plasmic-override={overrides.identifier}
        className={classNames("__wab_instance", sty.identifier)}
      />
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "companyNameInput",
    "contactNameInput",
    "emailInput",
    "identifier"
  ],

  companyNameInput: ["companyNameInput"],
  contactNameInput: ["contactNameInput"],
  emailInput: ["emailInput"],
  identifier: ["identifier"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAddClientModal__ArgProps,
          internalVariantPropNames: PlasmicAddClientModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAddClientModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAddClientModal";
  } else {
    func.displayName = `PlasmicAddClientModal.${nodeName}`;
  }
  return func;
}

export const PlasmicAddClientModal = Object.assign(
  // Top-level PlasmicAddClientModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    companyNameInput: makeNodeComponent("companyNameInput"),
    contactNameInput: makeNodeComponent("contactNameInput"),
    emailInput: makeNodeComponent("emailInput"),
    identifier: makeNodeComponent("identifier"),
    // Metadata about props expected for PlasmicAddClientModal
    internalVariantProps: PlasmicAddClientModal__VariantProps,
    internalArgProps: PlasmicAddClientModal__ArgProps
  }
);

export default PlasmicAddClientModal;
/* prettier-ignore-end */
